import React from 'react'
import GuidesPage from '../guidecards/GuidesPage';
import SearchBox from '../searchbox/Searchbox';
import GuidesData from './GuidesData';
import { useState } from 'react';
import { Box, Typography, Container ,Grid} from '@mui/material';

export default function Page() {
    

//const apiUrl = 'https://run.mocky.io/v3/6d72df2d-e13b-430e-89b9-66826419d65c';
//const guides =   GuidesData({ apiUrl });

const guides= [
    {
      "id": 1,
      "title": "Preparing for the Application",
      "description": "Your credit score is one of the most important factors that’s related to your financial health since lenders use this — as well as your credit report — to determine the interest rates you’ll qualify for when applying for any line of credit or loan.",
      "img": "ThumbArticle1"
    },
    {
      "id": 2,
      "title": "Filling out the Application Form",
      "description": "When filling out an application form, it's crucial to provide accurate and complete information to ensure a strong and professional representation of yourself. Here's a guide on how to approach filling out an application form effectively:",
      "img": "ThumbArticle2"
    },
    {
      "id": 3,
      "title": "Mortgage Loan Types",
      "description": "Not all home loans are the same, though. So, doing your research before moving forward can help you select the most suitable option for your financial situation and possibly keep more money in your pocket. Plus, you’ll know what to expect, in terms of guidelines, when you apply.",
      "img": "ThumbArticle3"
    },
    {
      "id": 4,
      "title": "Document Verification Process",
      "description": "The document verification process can usually be broken down into four steps: document collection, data extraction, document validation, and manual verification. Digital document verification can help you meet regulatory requirements, mitigate fraud, build trust, and onboard customers faster.",
      "img": "ThumbArticle4"
    },
    {
      "id": 5,
      "title": "Loan Approval and Closing",
      "description": "If your application meets the lender's criteria, you will receive a conditional loan approval. At this stage, the lender will issue a Loan Estimate, which details the loan terms, interest rate, closing costs, and monthly payment. It's essential to review this document carefully and compare it with offers from other lenders to ensure you're making an informed decision.",
      "img": "ThumbArticle5"
    },
    {
      "id": 6,
      "title": "Addressing Queries and Concerns",
      "description": "The process of securing a mortgage loan can be complex and often raises numerous questions and concerns. In this article, we aim to address some common queries and concerns related to mortgage loans, providing a clearer understanding of the process and empowering potential homebuyers to make informed decisions.",
      "img": "ThumbArticle6"
    }
  ];
const handleChangeParentState = (newState) => {
    console.log("called change state");
    setArticle(newState);
  };

const [articles,setArticle]=useState(guides);
  return (
   
 <Grid Container xs={12} > 

     { /*<SearchBox  changeParentState={handleChangeParentState} /> removed after asking */} 
    <GuidesPage  guides={articles} />
 
    </Grid>
  )
}
